export default (a, b, f) => {
    console.log(a, b, f)
  if (a && Array.isArray(a)) {
    let tot = a.filter(x => x.ar).reduce((accum, curr) =>  accum += curr[f], 0);

    if (b[f].toFixed(2) == tot.toFixed(2)) {
      return b[f];
    } else {
       
      return `${b[f]} (${tot.toFixed(2)})`;
    }
  }
  return null;
};
